import React from "react";
import { Divider, Flex, Row, Typography } from "antd";
import GloabalConst from "../../common/GloabalConst";
import { gray } from "@ant-design/colors";

const Footer = () => {
  return (
    <Row
      className="footer mx-3 w-full"
      style={{ height: "var(--height-menu)" }}
    >
      <Divider style={{ borderBlockStartColor: gray.primary,margin:'18px 0'  }} />
      <Flex justify="center" className="w-full">
        <div>
          Tổng đài:{" "}
          <Typography.Link href={`tel:${GloabalConst.HOTLINE}`}>
            {GloabalConst.HOTLINE}
          </Typography.Link>{" "}
          - Nhánh 1 | Email:{" "}
          <Typography.Link href={`mailto:${GloabalConst.MAIL_SUPPORT}`}>
            {GloabalConst.MAIL_SUPPORT}{" "}
          </Typography.Link>{" "}
          | Website:
          <Typography.Link href={`${GloabalConst.WEBSITE}`} target="_blank">
            {" "}
            {GloabalConst.WEBSITE}
          </Typography.Link>{" "}
        </div>
      </Flex>
    </Row>
  );
};

export default Footer;
